// import merge from 'lodash/merge';
import merge from 'lodash/merge';
import mergeDeep from '@utils/mergeDeep';
import { batchTypes } from '../constants';

const initialState = {
  data: {},
  batchDetails: {},
  topicGroups: {},
  testSeries: {},
  topicsWithConcepts: {},
  itemsInCourse: {},
  similarBatches: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case batchTypes.UPDATE_BATCHES:
      return {
        ...state,
        data: mergeDeep(action.data, state.data, 2)
      };

    case `${batchTypes.FETCH_BATCH_INFO}_SUCCESS`: {
      return {
        ...state,
        batchDetails: {
          ...state.batchDetails,
          [action.key]: action.result
        }
      };
    }

    case `${batchTypes.FETCH_TOPICS_COVERED}_SUCCESS`: {
      return {
        ...state,
        topicGroups: {
          ...state.topicGroups,
          [action.key]: action.result
        }
      };
    }

    case `${batchTypes.FETCH_TOPICS_WITH_CHILDREN}_SUCCESS`: {
      return {
        ...state,
        topicsWithConcepts: {
          ...state.topicsWithConcepts,
          [action.key]: action.result
        }
      };
    }

    case `${batchTypes.FETCH_ITEMS_IN_COURSE}_SUCCESS`: {
      return {
        ...state,
        itemsInCourse: {
          ...state.itemsInCourse,
          [action.key]: action.result
        }
      };
    }

    case `${batchTypes.ENROLL_IN_BATCH}_SUCCESS`: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.batchUID]: merge(state.data[action.batchUID], {
            isEnrolled: action.enroll
          })
        }
      };
    }

    case `${batchTypes.FETCH_CALENDAR_DATA}_SUCCESS`: {
      return {
        ...state,
        calendarData: {
          ...state.calendarData,
          [`${action.batchUID}_${action.month}`]: action.result
        }
      };
    }

    case `${batchTypes.FETCH_SCHEDULED_CLASSES}_REQUEST`:
      return {
        ...state,
        isFetchingSchedule: true,
        scheduledClasses: action.resetWithoutEmpty
          ? null
          : state.scheduledClasses
      };

    case `${batchTypes.FETCH_SCHEDULED_CLASSES}_SUCCESS`:
      return {
        ...state,
        isFetchingSchedule: false,
        scheduledClasses: action.resetWithoutEmpty
          ? {
              [action.key]: action.result
            }
          : {
              ...state.scheduledClasses,
              [action.key]:
                state.scheduledClasses[action.key] && action.result
                  ? {
                      previous:
                        action.direction === 'down'
                          ? state.scheduledClasses[action.key].previous
                          : action.result.previous,
                      next:
                        action.direction === 'up'
                          ? state.scheduledClasses[action.key].next
                          : action.result.next,
                      results:
                        action.direction === 'down'
                          ? [
                              ...state.scheduledClasses[action.key].results,
                              ...action.result.results
                            ]
                          : [
                              ...action.result.results,
                              ...state.scheduledClasses[action.key].results
                            ]
                    }
                  : action.result
            }
      };

    case `${batchTypes.FETCH_SIMILAR_BATCHES}_SUCCESS`:
      return {
        ...state,
        similarBatches: {
          ...state.similarBatches,
          [action.batchUID]: action.result
        }
      };

    default:
      return state;
  }
};

export default reducer;
